import React, { useState } from 'react';
import { X } from 'lucide-react';
import PatientCombobox from '../../components/PatientCombobox';
import ScheduleConsultationModal from './ScheduleConsultationModal';

/**
 * "Add Patient" entry point on the Consultations dashboard — picks an EXISTING patient (never
 * creates a new one, so the Patients table is never duplicated) and then reuses
 * ScheduleConsultationModal with that patientId preset, so the patient becomes visible in the
 * Consultations list without leaving the Patients module.
 */
export default function AddPatientToConsultationModal({ onClose, onCreated }) {
  const [patient, setPatient] = useState(null);

  if (patient) {
    return (
      <ScheduleConsultationModal
        patientId={patient.id}
        subjectName={patient.fullName}
        onClose={onClose}
        onCreated={onCreated}
      />
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add Patient to Consultations</h2>
          <button type="button" className="modal-close" onClick={onClose}><X size={18} /></button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label className="form-label">Find an existing patient *</label>
            <PatientCombobox value={patient} onChange={setPatient} autoFocus />
            <div className="td-muted" style={{ fontSize: '0.78rem', marginTop: 6 }}>
              Selecting a patient links them to a new consultation — it never creates a duplicate
              patient record.
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-outline" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
